import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Box, Container, Paper, Typography } from '@mui/material';
import { registerWithEmailAndPassword } from '../../firebase';
import {  useNavigate } from 'react-router-dom';

const SignUpForm = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    if (!name || !email || !password) {
      setErrorMessage('Please fill in all fields.');
      setSnackbarOpen(true);
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      setSnackbarOpen(true);
      return;
    }
    try {
      const response = await registerWithEmailAndPassword(name,email,password);
      if (response && response.message) {
        setErrorMessage(response.message);
        setSnackbarOpen(true);
        return;
      }
      setSuccessMessage('Account created! You can sign in now.');
      setSnackbarOpen(true);
      setTimeout(()=>navigate('/sign-in'), 800);
      setName('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  
  return (
    <Container maxWidth='sm'>
   <Paper sx={{backgroundColor:'secondary' , padding:4, mt:5}}>
      <Box sx={{width:'100%',textAlign:'center' }}><Typography variant='h4' component='h4'>Create an account</Typography></Box>
    <form onSubmit={handleSubmit}>
      <TextField
        label="Name"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Password"
        variant="outlined"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Confirm-Password"
        variant="outlined"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button type="submit" variant="contained" color="primary">
        Sign Up
      </Button>
      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
        <MuiAlert onClose={handleSnackbarClose} severity={errorMessage ? "error" : "success"} elevation={6} variant="filled">
          {errorMessage || successMessage}
        </MuiAlert>
      </Snackbar>
    </form>
    </Paper>
    </Container>
 
  );
};

export default SignUpForm;
